/**
 * Border gradient for the Tier 1 card.
 * Diagonal top-left to bottom-right, purple → white → deep purple.
 */
export const TIER_1_BORDER_GRADIENT =
  'linear-gradient(135deg, #BB5FFF 0%, #BB60FF 23%, #BE67FF 32%, #C373FF 38%, #CA84FF 43%, #D49AFF 47%, #DFB5FF 51%, #EDD5FF 54%, #FCFAFF 57%, #FFFFFF 57%, #EFE1FB 59%, #D7B2F5 61%, #C087F0 64%, #AD63EB 67%, #9D44E7 71%, #902BE4 74%, #8617E1 79%, #7F0AE0 83%, #7B02DF 89%, #7A00DF 100%)';

/**
 * Border gradient for the Tier 2 card.
 * Diagonal top-left to bottom-right, yellow-gold → pink → deep purple.
 */
export const TIER_2_BORDER_GRADIENT =
  'linear-gradient(120deg, #FBBF24 0%, #F9B62D 6%, #F39F47 15%, #EB7971 27%, #E046AA 41%, #D821D4 49%, #C91BD5 56%, #9E0CDA 75%, #8303DD 91%, #7A00DF 100%)';

/**
 * Border gradient for the "Reach Tier 2" / next-tier detail card.
 * Bottom-to-top, yellow → pink → purple.
 */
export const TIER_2_REACH_BORDER_GRADIENT =
  'linear-gradient(180deg, #FBBF24 0%, #FABA28 7%, #F7AD37 14%, #F2984E 22%, #EB7B6F 31%, #E35599 39%, #D927CC 48%, #D821D4 49%, #BF18D6 54%, #A60FD9 60%, #9208DC 67%, #8403DD 74%, #7C00DE 84%, #7A00DF 100%)';

/** Tier identity colors for display titles and non-current card titles. */
export const TIER_IDENTITY_COLORS: Record<string, string> = {
  'tier-1': '#8d8aa8',
  'tier-2': '#fbbf24',
};

/** Returns the identity color for a tier ID, defaulting to muted purple. */
export function getTierIdentityColor(tierId: string): string {
  return TIER_IDENTITY_COLORS[tierId] ?? '#8d8aa8';
}

/** Returns the border gradient for a tier ID. */
export function getTierBorderGradient(tierId: string): string {
  return tierId === 'tier-2' ? TIER_2_BORDER_GRADIENT : TIER_1_BORDER_GRADIENT;
}
